var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"mt-0 mr-0 pa-0",attrs:{"fluid":""}},[_c(_vm.story.content.component,{tag:"component",attrs:{"blok":_vm.story.content}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }